import { render, staticRenderFns } from "./WellnessBenefits.vue?vue&type=template&id=6e5c0f14"
import script from "./WellnessBenefits.vue?vue&type=script&lang=js"
export * from "./WellnessBenefits.vue?vue&type=script&lang=js"
import style0 from "./WellnessBenefits.vue?vue&type=style&index=0&id=6e5c0f14&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports